var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 64,
    viewBox: "0 0 83 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1968_374)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1968_374",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 83,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H82.56V62.8364H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1968_374)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.28 0C30.272 0 23.392 6.98182 20.64 20.9455C24.768 13.9636 29.584 11.3455 35.088 13.0909C38.2283 14.0858 40.4727 16.9775 42.9572 20.1755C47.0042 25.3867 51.6887 31.4182 61.92 31.4182C72.928 31.4182 79.808 24.4364 82.56 10.4727C78.432 17.4545 73.616 20.0727 68.112 18.3273C64.9717 17.3324 62.7273 14.4407 60.2428 11.2427C56.1958 6.03151 51.5113 0 41.28 0ZM20.64 31.4182C9.632 31.4182 2.752 38.4 0 52.3636C4.128 45.3818 8.944 42.7636 14.448 44.5091C17.5883 45.5059 19.8327 48.3956 22.3172 51.5937C26.3642 56.8048 31.0487 62.8364 41.28 62.8364C52.288 62.8364 59.168 55.8545 61.92 41.8909C57.792 48.8727 52.976 51.4909 47.472 49.7455C44.3317 48.7505 42.0873 45.8589 39.6028 42.6608C35.5558 37.4497 30.8713 31.4182 20.64 31.4182Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1968_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.56,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.4f708ddb1d1adf31dcd1c52856da4a50.svg";
export { ForwardRef as ReactComponent };